import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid2 as Grid, Typography, Box } from '@mui/material';

import { MediaCard } from '@carcareers/components';
import { usePostRecentQuery } from '@carcareers/store';
import { EmployerNew } from '@carcareers/assets';
import { Post } from '@libs/models';
import { routes } from '@carcareers/utils';

export const JobRecents: FC = () => {
  const { data: recentPosts, isLoading } = usePostRecentQuery();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <Grid container spacing={3} sx={{ mt: 4 }}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="body1">Loading recent job posts...</Typography>
        </Grid>
      </Grid>
    );
  }

  if (!recentPosts || recentPosts.length === 0) {
    return (
      <Box sx={{ mt: 4 }}>
        <MediaCard
          src={EmployerNew}
          alt="Post your first job"
          title="Post your first job"
          description="Create and post your first job to CARCAREERS.COM."
          onClick={() => navigate(`/${routes.EMPLOYER_HOME}/${routes.EMPLOYER_POST_A_JOB}`)}
        />
      </Box>
    );
  }

  return (
    <Grid container spacing={3} sx={{ mt: 4 }}>
      {recentPosts.map((post: Post, index: number) => {
        const title = post.job?.title || 'Job Posting';

        return (
          <Grid key={post.id} size={{ xs: 12, sm: 6, md: 4 }}>
            <MediaCard
              alt={title}
              title={title}
              description={'Manage your job and candidates for this job posting.'}
              onClick={() => navigate(`/${routes.EMPLOYER_HOME}/${routes.EMPLOYER_POSTS_INDEX}/${post.id}`)}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};
